<template>
  <section v-if="result?.collection" class="collection-look">
    <div class="collection-look-slider">
      <DefSlider ref="slider" :nav="screenWidth >= 992" :pagination="true" :settings="settings">
        <div
          v-for="item in items"
          :key="(item.offer && item.offer.id) || item.id"
          class="swiper-slide"
        >
          <CollectionLookCard :result="item" />
        </div>
      </DefSlider>
    </div>
    <a
      v-if="result.collection"
      :href="result.collection.detailPage"
      class="collection-look-picture"
    >
      <DefImg :result="result.collection.picture" />
    </a>
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import CollectionLookCard from '@components/card/CollectionLookCard/CollectionLookCard.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useScreenWidth from '@use/useScreenWidth';
import type { SwiperOptions } from 'swiper/types';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
const screenWidth = useScreenWidth();

const result = computed(() => resultsStore.mainPageCollectionLook);
const items = computed(() => result?.value.collection.displayProperties?.LOOK_PRODUCTS?.items);

const settings: SwiperOptions = {
  slidesPerView: 1,
  // slidesPerGroup: 2,
  breakpoints: {
    // 768: {},
    992: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-look {
  display: grid;
  grid-row-gap: 16px;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  margin-bottom: 60px;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 24px;
  }
  @include point-lg {
    margin-bottom: 80px;
  }
  @include point-xl {
    grid-template-columns: minmax(0, 1fr) minmax(0, 600px);
    grid-column-gap: 32px;
  }
}
.collection-look-picture {
  order: 1;
  @include point-md {
    order: 2;
  }
}
.collection-look-slider {
  order: 2;
  @include point-md {
    order: 1;
  }
  @include point-lg {
    padding: 0 32px;
  }
}
</style>
